<template>
  <el-dialog
    :title="currentTitle"
    :modal="false"
    :modal-append-to-body="true"
    :visible="value"
    @close="handleClose"
    width="60%"
    custom-class="agreement-dialog"
    :close-on-click-modal="false"
    :z-index="9999"
  >
    <div class="agreement-content">
      <template v-if="type === 'user'">
        <span>
          {{websit?websit.siteName:'' }}
          <br/>用户服务协议
        <br/>欢迎使用{{websit?websit.siteName:'' }}，为了保障您的权益，请在使用{{websit?websit.siteName:'' }}服务之前，详细阅读此服务协议（以下简称“本协议”）所有内容，特别是着重表述部分。
        <br/>本协议内容包括协议正文、本协议下述协议明确援引的其他协议、{{websit?websit.technicalSupport:'' }}已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，您使用{{websit?websit.siteName:'' }}服务均受本协议约束。

        <br/>第一条 定义
        <br/>{{websit?websit.siteName:'' }}指{{websit?websit.technicalSupport:'' }}所有和经营的有关教育、学习等数字内容聚合、管理和分发的平台产品，旨在为用户提供教学内容的生成、传播服务。

        <br/>第二条 {{websit?websit.siteName:'' }}服务协议的修订
        <br/>本协议及相关服务条款如由于业务发展需要进行修订的，{{websit?websit.technicalSupport:'' }}将在{{websit?websit.siteName:'' }}公布。您可前往查阅最新版协议条款。在{{websit?websit.technicalSupport:'' }}修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用{{websit?websit.siteName:'' }}服务。您继续使用{{websit?websit.technicalSupport:'' }}平台作品的行为将被视为已接受了修改后的协议。

        <br/>第三条 帐号使用规则
        <br/>1、您可浏览{{websit?websit.siteName:'' }}上的课程信息，如您希望学习该课程，您需先登录您的帐号，（登录前需先行注册）。您在学习课程时登录的帐号是{{websit?websit.technicalSupport:'' }}确认您身份的唯一依据。
        <br/>2、您确认：您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，有能力对您使用{{websit?websit.siteName:'' }}服务的一切行为独立承担责任。若您不具备前述主体资格，{{websit?websit.technicalSupport:'' }}在依据法律规定或本协议约定要求您承担责任时，有权要求您的监护人担责。
        <br/>3、您在使用{{websit?websit.siteName:'' }}服务时填写、登录、使用的帐号名称、头像、个人简介等帐号信息资料应遵守法律法规、社会主义制度要求、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息，且您保证在填写、登录、使用帐号信息资料时，不得有以下情形：
        <br/>（1）违反宪法或法律法规规定的；
        <br/>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        <br/>（3）损害国家荣誉和利益的，损害公共利益的；
        <br/>（4）煽动民族仇恨、民族歧视，破坏民族团结的；
        <br/>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；
        <br/>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；
        <br/>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        <br/>（8）侮辱或者诽谤他人，侵害他人合法权益的；
        <br/>（9）含有法律、行政法规禁止的其他内容的。
        <br/>若用户登录、使用帐号头像、个人简介等帐号信息资料存在违法和不良信息的，{{websit?websit.technicalSupport:'' }}有权采取通知限期改正、暂停使用等措施。对于冒用关联机构或社会名人登录、使用、填写帐号名称、头像、个人简介的，{{websit?websit.technicalSupport:'' }}有权取消该帐号在{{websit?websit.siteName:'' }}上使用，并向政府主管部门进行举报。
        <br/>4、您应保管好自己的帐号和密码，如因您未保管好自己的帐号和密码而对自己、{{websit?websit.technicalSupport:'' }}或第三方造成损害的，您将自负全部责任。另外，您应对您帐号中的所有活动和事件负全责。您可随时改变帐号的密码。您同意若发现有非法使用您的帐号或出现安全漏洞的情况，立即通告{{websit?websit.technicalSupport:'' }}，{{websit?websit.technicalSupport:'' }}将会尽力予以妥善解决。

        <br/>第四条 数据
        <br/>除非另有证明，{{websit?websit.technicalSupport:'' }}储存在其服务器上的数据是您使用{{websit?websit.siteName:'' }}服务的唯一有效证据。

        <br/>第五条 {{websit?websit.siteName:'' }}使用规则
        <br/>1、您须对自己在使用{{websit?websit.siteName:'' }}服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿；以及在{{websit?websit.technicalSupport:'' }}首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予{{websit?websit.technicalSupport:'' }}等额的赔偿。
        <br/>2、您了解并同意，{{websit?websit.technicalSupport:'' }}有权应有关权力部门的要求，向其提供您提交给{{websit?websit.technicalSupport:'' }}或在使用{{websit?websit.siteName:'' }}服务中存储于{{websit?websit.technicalSupport:'' }}服务器的必要信息。如您涉嫌侵犯他人合法权益，则{{websit?websit.technicalSupport:'' }}有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供关于您的前述必要信息。

        <br/>第六条 其他约定
        <br/>1、不可抗力：
        <br/>{{websit?websit.technicalSupport:'' }}对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。
        <br/>2、服务中止、中断及终止：{{websit?websit.technicalSupport:'' }}根据自身商业决策等原因可能会选择中止、中断及终止平台服务。如有此等情形发生，{{websit?websit.technicalSupport:'' }}会采取公告的形式通知您。经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者{{websit?websit.technicalSupport:'' }}根据自身的判断，认为您的行为涉嫌违反《网易邮箱服务条款》、本协议内容或{{websit?websit.siteName:'' }}不时公布的使用规则等内容，或涉嫌违反法律法规的规定的，则{{websit?websit.technicalSupport:'' }}有权中止、中断或终止向您提供服务，且无须为此向您或任何第三方承担责任。
        <br/>3、所有权及知识产权：{{websit?websit.technicalSupport:'' }}平台上所有内容，包括但不限于文字、软件、声音、图片、录像、图表、网站架构、网站画面的安排、网页设计、{{websit?websit.technicalSupport:'' }}为您提供的标有“版权所有，禁止转载”字样的教育内容均由{{websit?websit.technicalSupport:'' }}或其他权利人依法拥有其知识产权，包括但不限于著作权、商标权、专利权等。非经{{websit?websit.technicalSupport:'' }}或其他权利人书面同意不得擅自使用、修改、复制、传播、改变、散布、发行或发表上述内容。如有违反，您同意承担由此给{{websit?websit.technicalSupport:'' }}或其他权利人造成的一切损失。
        <br/>4、通知：所有发给您的通知都可通过电子邮件、常规的信件或在网站显著位置公告的方式进行传送。
        <br/>5、本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。
        <br/>6、本协议自发布之日起实施，并构成您和{{websit?websit.technicalSupport:'' }}之间的共识。
        <br/>7、{{websit?websit.technicalSupport:'' }}不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响{{websit?websit.technicalSupport:'' }}在将来行使该权利。
        <br/>8、如果您对本协议内容有任何疑问，请联系我们，服务热线：（010）81791868。
</span>
      </template>
      <template v-if="type === 'privacy'">
        <span>隐私政策
          <br/>（本隐私政策适用于{{websit?websit.siteName:'' }}）
          <br/>更新日期：2023年10月17日
          <br/>{{websit?websit.technicalSupport:'' }}及其关联公司（下文简称“恩数互联”、“我们”和“我们的”）深知隐私对您的重要性，并会尊重您的隐私。请在向恩数互联提交个人数据之前，阅读、了解本《隐私政策》（下文简称“本政策”）。本政策适用于显示本隐私政策、或链接至本隐私政策的恩数互联网站和产品、服务。
          <br/>本政策阐述了如何处理您的个人数据，但本政策可能并不涉及所有可能的数据处理情境。有关收集产品或服务特定数据的信息可能由恩数互联在补充政策中，或者在收集数据时提供的通知中发布。
          <br/>如果您是未成年人，您的监护人需要仔细阅读本政策并同意您依照本政策使用我们的产品及服务。
          <br/>本隐私协议向您展示以下内容：
          <br/>引言
          <br/>一、我们收集的信息
          <br/>二、我们如何使用所收集的信息
          <br/>三、对于共享、转让、公开披露个人信息的处理方式
          <br/>四、我们如何保存您的个人信息

          <br/>五、我们如何保护您的个人信息
          <br/>六、您如何管理自己的个人信息
          <br/>七、未成年人信息条款
          <br/>八、政策变更的处理
          <br/>联系我们
          <br/>引言
          <br/>个人信息：如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息;当您的信息可以单独或结合其他信息识别到您的个人身份时，或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。
          <br/>在您本服务的过程中，我们将根据合法、正当、必要的原则，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以保障产品的正常运行和功能、改善产品和服务以及保障用户使用安全。
          <br/>一、我们收集的信息
          <br/>在您本服务的过程中，我们将根据合法、正当、必要的原则，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以保障产品的正常运行和功能、改善产品和服务以及保障用户使用安全。
          <br/>（一）注册、登录、认证、注销
          <br/>1. 如果您使用第三方账号登录并使用本服务，您将授权我们获取您在第三方平台注册的公开信息(头像、昵称以及您授权的其他信息)，用以和本服务绑定并保存您的登录信息，使您可以登录并使用本服务和相关服务。
          <br/>2. 根据具体使用情况，您可能需要提供您的真实身份信息(真实姓名、身份证号码、电话号码)以完成实名验证。这些信息属于个人敏感信息，您可以拒绝提供，但您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。
          <br/>3. 如果您使用第三方账号登录并使用本服务，您将授权我们使用您的好友关系、您在服务中的相关操作信息、服务信息等信息（具体包括但不限于您的登录状态、对战信息/状态、成就信息等）以及您授权的其他信息，用于向您本人或其他用户或好友展示。我们可能会视服务产品具体情况为您提供相关权限，以便您可以对是否展示前述相关信息进行相应设置。
          <br/>4. 您可以在客户端-个人-设置中申请帐号注销。在您注销帐号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销帐号的行为是不可逆的行为，当您注销帐号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规及相关国家标准另有规定的除外。
          <br/>（二）程序正常、安全运行

          1. 为了保障软件与服务的安全、正常运行，我们会收集您的硬件型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP地址、WLAN接入点、MAC地址、Android ID、应用ID、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志等信息。如您使用魅族、华为等品牌手机，服务接入的上述手机厂商PushSDK需要收集手机唯一标识信息（例如IMEI），并可能会收集您的设备屏幕尺寸等参数。

          2. 为了使您能够在客户端查看您的服务历史记录，同时用于判断账户安全、进行身份验证、检测及防范安全事件、服务运营统计分析、客服投诉处理及其他服务安全分析，并为提升您的服务体验，我们会收集您的账户信息、设备信息、服务日志信息以及我们关联公司、合作方在获得您授权或依法可以共享的信息、您使用应用程序和服务的信息，例如登录日志、物品日志、服务对局信息、交友记录、应用程序和服务产生的连接和服务相关的数据信息、网络测试、服务质量、日期、时间和地理位置等。

          3. 为了预防恶意程序及安全、稳定运营，我们可能会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。

          4. 当您使用的服务产品具有消费功能，我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录并保护您的虚拟物品安全。

          5. 我们可能会收集并保存您在服务中通过文字、图片、语音、视频及其他方式与其他人进行的互动，用于过滤色情、暴力、恶意广告等不当内容。

          6. 根据服务和服务内容，在您授权同意后，服务会访问您的麦克风、摄像头，为您提供语音聊天、直播互动等功能。

          （三）申请授权的权限、目的及所涉个人信息

          为更好的为您提供服务，保障程序正常、安全运行，我们将向您申请以下权限。以下权限的申请方式包括但不限于：弹窗提示、界面提示等。

          同一权限在不同终端设备上的获取方式可能有所不同，具体以您使用的终端设备实际采用方式为准。

          向您申请的部分权限由我们的合作厂商SDK获取，关于合作厂商SDK请参考第四部分。

          1.我们将会使用网络以执行用户服务信息获取，参数调取下发，包括病毒库更新、垃圾缓存数据库、接受版本更新信息等。

          2.我们将使用读取、修改存储设备的内容权限来查看存储在设备上文件并对文件执行操作，从而完成向用户显示有关信息，下载并安装APP以及下载查看相关文件的目的。

          3.我们将获取您的手机状态，以让我们识别您的手机设备，从而将用户服务中的重要数据和设备绑定，防止数据丢失。

          4.我们将获取追踪用户安装来源的权限，用于判断用户从何渠道安装了本服务。

          5.我们可能会获取访问粗略的位置（基站、wifi）权限，用于部分服务中用户排行榜，用户沟通交互用途。

          6.我们还可能需要获取其他权限以满足特定需求和功能，如有发生，我们将通过适当的方式通知您并获得您的同意和授权。

          （四）根据相关法律法规及国家标准，我们可能会收集、使用您的相关个人信息且无需征求您的授权同意：

          1. 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；

          2. 与犯罪侦查、起诉、审判和判决执行等直接相关的；

          3. 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；

          4. 所收集的个人信息是您自行向社会公众公开的；

          5. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；

          6. 根据您要求签订和履行合同所必需的；

          7. 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；

          8. 为开展合法的新闻报道所必需的；

          9. 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；

          10. 法律法规规定的其他情形。

          二、所收集信息的使用

          我们严格遵守法律法规的规定以及与用户的约定，按照本政策所述使用收集的信息，以向您提供更为优质的服务。

          信息使用规则

          （一）我们会按照如下规则使用收集的信息：

          1. 我们会根据我们收集的信息向您提供各项功能与服务，包括基础服务功能、消费功能等；

          2. 我们会根据您使用产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合；

          3. 为了让您获得更好的体验、改善我们的服务，我们可能将通过某一项服务所收集的信息，以汇集信息，用于我们的其他服务。例如，在您注册某一个产品账号时，为了避免重复注册，我们将对您注册的账号进行本公司内服务唯一性校验，以方便您在使用我们其他产品时可以直接进行登录；

          4. 软件认证或管理软件升级；

          5. 邀请您参与有关我们产品和服务的调查；

          6. 我们可能在必要时(例如因系统维护而暂停某一项服务时)向您发出与服务有关的公告。您可能无法取消和限制这些与服务有关且性质不属于推广的公告；

          7. 我们将在本政策所覆盖的用途内使用收集的信息。如我们使用您的个人信息超出了收集时所声称的目的、及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。

          （二）告知变动目的后征得同意的方式

          当本服务与我们当前提供的功能或服务与原处理目的无直接或合理关联的时，我们收集、使用您的个人信息时，会再次进行告知，并征得您的同意。如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，并再次征得您的明示同意。

          （三）停止运营后的信息处理

          如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。

          三、对于共享、转让、公开披露个人信息的处理方式

          （一）基本内容

          1. 除本政策规定的情形外，我们不会主动共享、提供或转让您的个人信息至第三方，如存在其他共享、提供或转让您的个人信息或您需要我们将您的个人信息共享、提供或转让至第三方情形的，我们会直接或确认该第三方征得您对上述行为的明示同意。

          2. 除本政策另有规定，或遵循国家法律法规规定或者获得您的同意外，我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会采用符合行业内标准的安全保护措施，并我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。

          3. 我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。

          （二）共享

          1. 如向我们的关联方、第三方共享您的个人信息，需经过您的授权同意，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果关联方、第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。

          2. 我们向关联方、第三方共享的数据将具有合法正当目的，且共享的数据以达成目的必要为限。

          3. 我们将审慎评估关联方、第三方数据使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包(SDK)、应用程序接口(API)进行严格的安全监测，以保护数据安全。请您注意：第三方SDK会在您使用本服务的情况下收集您的部分信息，拒绝提供可能会导致您无法登录本服务或在使用本服务过程中受到相应限制。通过本服务为您提供服务的第三方SDK，会根据其自身隐私政策所述标准存储、使用、处理和保护您的个人信息，本隐私政策不能代替上述第三方的隐私政策。我们会审慎选择接入的第三方SDK并尽力要求第三方SDK为您的个人信息安全提供足够的保护，同时强烈建议您在使用上述第三方SDK服务前先行阅读其相关隐私政策（具体接入第三方SDK目录表详见后文），请您审慎了解、确认其隐私保护情况，做出您认为适当的选择，并且您明确知晓，对于您的自由选择出现的任何后果由您本人自行承担，我们不对此承担任何责任。

          4. 当您在使用本服务中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供服务时，我们会将去标识化后的个人信息与这些关联方、第三方共享，进行综合统计并通过算法做特征与偏好分析趣的信息。

          5. 为保障使用安全和分析使用情况，我们和关联公司或服务提供商可能会共享必要的设备、账号及日志信息、产品使用情况(崩溃、闪退)的统计性数据，这些数据难以与其他信息结合识别您的个人身份。

          （三）根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息且无需事先征得您的授权同意：

          1. 与国家安全、国防安全直接相关的；

          2. 与公共安全、公共卫生、重大公共利益直接相关的；

          3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；

          4. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；

          5. 个人信息主体自行向社会公众公开个人信息的；

          6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。

          四、信息的储存

          （一）我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。

          （二）我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。

          （三）在您使用公司服务期间，我们会持续保存您的个人信息。对于其他数据的保存期限，我们承诺是为了实现提供服务所必须的最短期限，在超出上述期限后，我们会对您的相关信息进行删除或匿名化处理。

          五、信息的保护

          （一）我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括身份鉴别、数据加密、访问控制、恶意代码防范、安全审计、技术保护手段、管理制度控制、安全体系保障等诸多方面。

          （二）尽管我们采取上述合理有效措施，并遵守相关法律规定要求的标准，但请您理解，由于技术的限制、可能存在的各种恶意手段、我们可控范围外的系统和通讯网络等方面的问题，我们难以始终保证信息百分之百的安全，但我们将尽力确保您提供给我们的个人信息的安全性，我们也建议您在使用产品和服务时充分注意对个人信息的保护，建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。

          （三）若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示

          （四）若您一旦离开本服务及相关服务，浏览或使用其他网站、服务及内容资源，无论您登录、浏览或使用上述软件、网站是否基于本服务的链接或引导，我们将没有能力和义务保护您对该等软件、网站提交的任何个人信息。

          六、您的权利

          在您使用本服务和服务期间，我们可能会视服务产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息、注销您的账户及撤回您已同意的授权，您可参考本服务的具体指引进行操作。此外，我们还设置了投诉、请求及举报渠道，您的意见将会得到及时的处理。

          具体操作方式为：

          1.查询/删除功能：在【联系我们】中获取联系邮箱，向我们发送邮件进行查询和删除；

          2.改变授权范围：通过手机系统权限设置，进行授权范围改变，若有任何需要帮助的，可随时通过邮箱联系我们进行处理；

          3.投诉、举报：在【联系我们】中获取联系邮箱，向我们发送邮件对相关行为进行投诉和举报；

          七、未成年人条款

          （一）若您是未满18周岁的未成年人，在使用本服务及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本政策。

          （二）我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、储存、共享、转让或披露未成年人的个人信息;如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，会设法尽快删除相关信息。

          （三）若您是未成年人的法定监护人，请您关注您所监护的未成年人是否是在取得您的授权同意之后使用本服务的服务或提供其个人信息。如果您对您所监护的未成年人的个人信息有疑问，请通过本政策中的联系方式与我们联系。

          （四）对于可能涉及的不满14周岁的儿童个人信息，我们除遵守本政策关于用户个人信息的约定外，还会严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露。

          八、政策变更

          （一）我们会适时对本政策进行修订、补充或变更，这些修订、补充或变更构成本政策的一部分并具有等同于本政策的效力。未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。

          （二）本政策更新前，我们会通过服务页面显著位置提示或向您发送电子邮件等适当方式通知您，以便您及时了解本政策的最新版本。再次征得您的明示同意后，我们将按照更新后的隐私政策收集、处理或使用您的个人信息。

          联系我们

          如果您对个人信息保护问题有投诉、建议、疑问，您可以将问题发送至【邮箱号：support@ndlink.cn】，我们将尽快审核所涉问题，并在验证您的用户身份后的十五个工作日内予以回复。

</span>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from '@/store'
export default {
  name: 'AgreementDialog',
  props: {
    value: { type: Boolean, default: false },
    type: { type: String, required: true, validator: v => ['user', 'privacy'].includes(v) }
  },
  computed: {
    currentTitle () {
      return this.type === 'user' ? '用户协议' : '隐私协议'
    },
    websit () {
      return store.getters.websit || {}
    }
  },
  mounted () {
    console.log(store)
  },
  methods: { handleClose () { this.$emit('input', false) } }
}
</script>

<style scoped>
::v-deep .agreement-dialog {
  max-height: 50vh !important;
  display: flex !important;
  flex-direction: column;
  z-index: 9999 !important;
  position: relative !important;
}

.agreement-content {
  max-height: calc(50vh - 120px) !important;
  overflow-y: auto;
  padding: 15px 20px;
  text-align: left;
  font-size: 14px;
  line-height: 1.8;
  flex: 1;
}

::v-deep .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 9998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
}

::v-deep .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

/* 弹窗内容容器 */
::v-deep .el-dialog__body {
  padding: 0 !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/agreementDialog.vue